/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../app/util/ErrorUtils',
	'underscore'
], function(Utils, _) {

	class ActionHandler {

		/**
		 * Menu item handler
		 */
		onSelectItem(context) {
			this._openCreateView(context);
		}

		/**
		 * Determine when we show/hide the menu item
		 */
		isItemVisible(options) {
			return this.canExecute(options);
		}

		/**
		 * Default action handler
		 */
		doAction(context) {
			return this._openCreateView(context);
		}

		/**
		 * Determine if we can execute the action based on the selection
		 */
		canExecute(options) {
			const isSelectionAllowed = this._isSelectionValid(options, true);
			return Utils.hasCapability(options.glassContext, 'canAuthorDashboard') && isSelectionAllowed;
		}

		_openCreateView(context) {
			var perspectiveOptions = {
				content: {}
			};
			var sources = this._getSources(context);
			if (sources && sources.length > 0) {
				perspectiveOptions.content.sources = sources;
			}
			return context.glassContext.appController.openAppView('createBoard', perspectiveOptions);
		}

		_getSources(options) {
			var isSelectionValid = this._isSelectionValid(options, false);
			var dataSourcesArray = null;
			if (isSelectionValid) {
				dataSourcesArray = [];
				var selections = options.target.activeObject.aSelectedContext;
				for (var i = 0; i < selections.length; i++) {
					dataSourcesArray.push({
						assetId: selections[i].id,
						type: selections[i].type,
						name: selections[i].defaultName,
						searchPath: selections[i].searchPath,
						isOlapPackage: selections[i].userInterfaces && _.indexOf(selections[i].userInterfaces, 'analysisStudio') >= 0
					});
				}
			}

			return dataSourcesArray;
		}

		_isSelectionValid(options, defaultValue) {
			const typesToOpen =  ['module', 'dataSet2', 'uploadedFile', 'package', 'data_asset'];
			var selection = options.target && options.target.activeObject && options.target.activeObject.aSelectedContext;
			if (selection) {
				for (var i = 0; i < selection.length; i++) {
					// The item must be either module or uploaded File
					var aType = typesToOpen;
					if (_.intersection([selection[i].type], aType).length < 1) {
						return false;
					}

					// The item must have read permission
					var aPerm = ['read'];
					if (_.intersection(selection[i].permissions, aPerm).length < aPerm.length) {
						return false;
					}

					// The item must not be disabled
					if (selection[i].disabled && selection[i].disabled.toString().toLowerCase() === 'true') {
						return false;
					}
				}
				return true;
			}
			return defaultValue || false;
		}
	}

	return ActionHandler;
});
